<template>
  <proa-modal
    :modal="selectOrganizationModal"
    :title="$t('common.changeOrganization')"
    @close="onClose"
  >
    <proa-select
      v-model="changeOrganizationId"
      :options="organizationOptions"
    />
    <template slot="footer">
      <proa-button
        @click.native="onClickChangeOrganization"
        :loading="false"
        :disabled="changeOrganizationId == currentOrganization.id"
        class="default-button-width"
        variant="primary"
      >
        {{ $t('common.ok') }}
      </proa-button>
    </template>
  </proa-modal>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'

import Organization from '@/store/models/Organization'

export default {
  name: 'SelectOrganizationModal',
  computed: {
    organizations: function() { return Organization.all() },
    organizationOptions: function() {
      return this.organizations.map(organization => {
        const disabledMessage = organization.adminUserId == this.signedInUser.id ? '（この組織のお支払い情報に問題があります）' : '（この組織は現在利用できません）'
        return {
          label: organization.isActivated ? organization.name : organization.name + disabledMessage,
          value: organization.id,
          selected: organization.isActivated && organization.id == this.currentOrganization.id,
          disabled: !organization.isActivated && organization.adminUserId != this.signedInUser.id
        }
      })
    },
    ...mapGetters({
      currentOrganization: 'auth/currentOrganization',
      selectOrganizationModal: 'selectOrganizationModal',
      signedInUser: 'auth/signedInUser'
    })
  },
  data() {
    return {
      changeOrganizationId: null
    }
  },
  methods: {
    onClose: function() {
      this.setSelectOrganizationModal(false)
    },
    async onClickChangeOrganization() {
      await this.apiPutAuth({
        defaultOrganizationId: this.changeOrganizationId
      })
      window.location = '/'
    },
    ...mapMutations({
      setSelectOrganizationModal: 'setSelectOrganizationModal'
    }),
    ...mapActions({
      apiPutAuth: 'auth/update'
    })
  },
  watch: {
    selectOrganizationModal: function(value) {
      if (value) {
        this.changeOrganizationId = this.currentOrganization.id
      }
    }
  }
}
</script>
